import baseService from './baseService';
const ENROLL_TIMEOUT_MS = 75000;
const promotionService = {
    enroll: function(enrollmentData) {
        return baseService.postJson("promotion/enroll", enrollmentData, ENROLL_TIMEOUT_MS);
    }
};
export default promotionService;